import PropTypes from "prop-types";

import ServiceWrapper from "../utils/ServiceWrapper";

import {
    EPR_ACTION_WINDOWS,
    EPR_ARCHIVE_GRADING_PROFILES,
    EPR_DOWNLOAD,
    EPR_GRADING_PROFILE,
    EPR_RESOURCE_DOWNLOAD,
    EPR_RESOURCES,
    EPR_STATUS,
    EPR_TIMEPERIODS_BY_SCHOOL_YEAR
} from "../const/GuardianEprConst";

/**
 * Data Access for the EPR API
 * @name GuardianEprDao
 * @param {*} props
 * @returns {Promise<any>}
 */
const GuardianEprDao = async (props) => {
    const { action, gradingProfileId, key, locationKey, params, schoolYearKey, studentNumber, token } = props;
    const bearer = `Bearer ${token}`;
    const options = {
        headers: {
            Authorization: bearer
        },
        withCredentials: true
    };
    switch (action) {
        case "archiveGradingProfilesRead":
            options.method = "GET";
            options.url = `${EPR_ARCHIVE_GRADING_PROFILES}/${studentNumber}/${schoolYearKey}/index.json`;
            break;
        case "eprActionWindowsRead":
            options.method = "GET";
            options.url = `${EPR_ACTION_WINDOWS}/${schoolYearKey}/LOCATION/${locationKey}/index.json`;
            break;
        case "eprPdfDownload":
            options.responseType = "blob";
            options.headers.Accept = "application/pdf";
            options.method = "GET";
            options.url = `${EPR_DOWNLOAD}/${studentNumber}/${gradingProfileId}/detail.json`;
            break;
        case "eprGradingProfileRead":
            options.method = "GET";
            options.url = `${EPR_GRADING_PROFILE}/${studentNumber}/${schoolYearKey}/index.json`;
            break;
        case "eprResourceDownload":
            options.method = "GET";
            if (params) {
                options.params = params;
            }
            options.responseType = "blob";
            options.url = `${EPR_RESOURCE_DOWNLOAD}/${key}/file`;
            break;
        case "eprStatusRead":
            options.method = "GET";
            options.url = `${EPR_STATUS}/${studentNumber}/${schoolYearKey}/detail.json`;
            break;
        case "eprStudentResourcesRead":
            options.method = "GET";
            if (params) {
                options.params = params;
            }
            options.url = `${EPR_RESOURCES}/${gradingProfileId}/index.json`;
            break;
        case "timePeriodsBySchoolYearRead":
            options.method = "GET";
            options.url = `${EPR_TIMEPERIODS_BY_SCHOOL_YEAR}/${schoolYearKey}/index.json`;
            break;
        default:
            return null;
    }

    const response = await ServiceWrapper.serviceCall({
        options,
        ...props
    });

    return response;
};

GuardianEprDao.propTypes = {
    action: PropTypes.string.isRequired,
    gradingProfileId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    key: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    locationKey: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    params: PropTypes.oneOfType([PropTypes.object]),
    schoolYearKey: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    studentNumber: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    token: PropTypes.string.isRequired
};

GuardianEprDao.defaultProps = {
    gradingProfileId: null,
    key: null,
    locationKey: null,
    params: null,
    schoolYearKey: null,
    studentNumber: null
};

export default GuardianEprDao;
